import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BatchAddModel } from 'src/app/core/models/masters/batch-add.model';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { AutoStringCreationComponent } from '../auto-string-creation/auto-string-creation.component';
import { SerialAddModel } from 'src/app/core/models/masters/serial-add.model';

@Component({
  selector: 'app-auto-batch-serial-creation',
  templateUrl: './auto-batch-serial-creation.component.html',
  styleUrls: ['./auto-batch-serial-creation.component.css']
})
export class AutoBatchSerialCreationComponent {
  local_data: any;
  isBatch = true;
  batchItem: BatchAddModel = new BatchAddModel();
  serialItem: SerialAddModel = new SerialAddModel();
  autoStringCreation: any = []
  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
              public snackbarService: BaseService<any>) { 
    this.local_data = data;
    this.isBatch = this.local_data.manageBatchNumbers == "Y";            
  }

  onBatchSerialCreation() {
    if(this.isBatch) {
      if(this.batchItem.numOfBatch && this.batchItem.batchNumber) {
        this.dialogRef.close({ 
          event: true, 
          value: this.batchItem,
          autoStringCreation: this.autoStringCreation
        });
      }else {
        this.snackbarService.showMessage('Please fill the mandatory fields', 'X');
      }
    }else {
      if(this.serialItem.internalSerialNumber && this.serialItem.manufacturerSerialNumber) {
        this.dialogRef.close({ 
          event: true, 
          value: this.serialItem,
          autoStringCreation: this.autoStringCreation
        });
      }else {
        this.snackbarService.showMessage('Please fill the mandatory fields', 'X');
      }
    }
  }

  showAutoStringPopup(label: string, type: number) {
    this.local_data.label = label;
    this.local_data.type = type;
    this.dialog.open(AutoStringCreationComponent, {data: this.local_data}).afterClosed()
    .subscribe(res => {
      const response = res.value;
      console.log(response);
      // if(this.isBatch) {
      //   if(type == 0) {
      //     this.batchItem.BatchNumber = `${response[0].text}${response[1].text}`
      //   }else if(type == 1) {
      //     this.batchItem.InternalSerialNumber = `${response[0].text}${response[1].text}`
      //   }else {
      //     this.batchItem.ManufacturerSerialNumber = `${response[0].text}${response[1].text}`
      //   }
      // }else {
      //   if(type == 0) {
      //     this.serialItem.ManufacturerSerialNumber = `${response[0].text}${response[1].text}`
      //   }else if(type == 1) {
      //     this.serialItem.InternalSerialNumber = `${response[0].text}${response[1].text}`
      //   }else {
      //     this.serialItem.BatchID = `${response[0].text}${response[1].text}`
      //   }
      // }
      if(this.isBatch) {
        if(type == 0) {
          this.batchItem.batchNumber = `${response[0].text}${response[1].text}`
        }else if(type == 1) {
          this.batchItem.internalSerialNumber = `${response[0].text}${response[1].text}`
        }else {
          this.batchItem.manufacturerSerialNumber = `${response[0].text}${response[1].text}`
        }
      }else {
        if(type == 0) {
          this.serialItem.manufacturerSerialNumber = `${response[0].text}${response[1].text}`
        }else if(type == 1) {
          this.serialItem.internalSerialNumber = `${response[0].text}${response[1].text}`
        }else {
          this.serialItem.batchID = `${response[0].text}${response[1].text}`
        }
      }
      this.autoStringCreation.push({type: type, criteria: response});
    })
  }
}
